/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteNodeResponse } from '../models';
// @ts-ignore
import type { DrainNodeRequest } from '../models';
// @ts-ignore
import type { DrainNodeResponse } from '../models';
// @ts-ignore
import type { InterruptNodeRequest } from '../models';
// @ts-ignore
import type { InterruptNodeResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * NodesAPIApi - axios parameter creator
 * @export
 */
export const NodesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a node.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeName The name of the node.
         * @param {boolean} [force] Force deletion without waiting for the cluster to reach a stable state.  WARNING: This may leave dangling resources in the cluster. Use with caution.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAPIDeleteNode: async (organizationId: string, clusterId: string, nodeName: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodesAPIDeleteNode', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodesAPIDeleteNode', 'clusterId', clusterId)
            // verify required parameter 'nodeName' is not null or undefined
            assertParamExists('nodesAPIDeleteNode', 'nodeName', nodeName)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/nodes/{nodeName}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeName"}}`, encodeURIComponent(String(nodeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drains a node of all workloads.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeName The name of the node.
         * @param {DrainNodeRequest} drainNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAPIDrainNode: async (organizationId: string, clusterId: string, nodeName: string, drainNodeRequest: DrainNodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodesAPIDrainNode', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodesAPIDrainNode', 'clusterId', clusterId)
            // verify required parameter 'nodeName' is not null or undefined
            assertParamExists('nodesAPIDrainNode', 'nodeName', nodeName)
            // verify required parameter 'drainNodeRequest' is not null or undefined
            assertParamExists('nodesAPIDrainNode', 'drainNodeRequest', drainNodeRequest)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/nodes/{nodeName}:drain`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeName"}}`, encodeURIComponent(String(nodeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(drainNodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Interrupts a node.  (-- api-linter: core::0122::cast-api-resource-id-name=disabled      aip.dev/not-precedent: The node API uses the Kubernetes node name as the resource identifier. --)
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeName The name of the node.
         * @param {InterruptNodeRequest} interruptNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAPIInterruptNode: async (organizationId: string, clusterId: string, nodeName: string, interruptNodeRequest: InterruptNodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodesAPIInterruptNode', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodesAPIInterruptNode', 'clusterId', clusterId)
            // verify required parameter 'nodeName' is not null or undefined
            assertParamExists('nodesAPIInterruptNode', 'nodeName', nodeName)
            // verify required parameter 'interruptNodeRequest' is not null or undefined
            assertParamExists('nodesAPIInterruptNode', 'interruptNodeRequest', interruptNodeRequest)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/nodes/{nodeName}:interrupt`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeName"}}`, encodeURIComponent(String(nodeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interruptNodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodesAPIApi - functional programming interface
 * @export
 */
export const NodesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a node.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeName The name of the node.
         * @param {boolean} [force] Force deletion without waiting for the cluster to reach a stable state.  WARNING: This may leave dangling resources in the cluster. Use with caution.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodesAPIDeleteNode(organizationId: string, clusterId: string, nodeName: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteNodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodesAPIDeleteNode(organizationId, clusterId, nodeName, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodesAPIApi.nodesAPIDeleteNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Drains a node of all workloads.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeName The name of the node.
         * @param {DrainNodeRequest} drainNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodesAPIDrainNode(organizationId: string, clusterId: string, nodeName: string, drainNodeRequest: DrainNodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DrainNodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodesAPIDrainNode(organizationId, clusterId, nodeName, drainNodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodesAPIApi.nodesAPIDrainNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Interrupts a node.  (-- api-linter: core::0122::cast-api-resource-id-name=disabled      aip.dev/not-precedent: The node API uses the Kubernetes node name as the resource identifier. --)
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} nodeName The name of the node.
         * @param {InterruptNodeRequest} interruptNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodesAPIInterruptNode(organizationId: string, clusterId: string, nodeName: string, interruptNodeRequest: InterruptNodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterruptNodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodesAPIInterruptNode(organizationId, clusterId, nodeName, interruptNodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodesAPIApi.nodesAPIInterruptNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodesAPIApi - factory interface
 * @export
 */
export const NodesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodesAPIApiFp(configuration)
    return {
        /**
         * Deletes a node.
         * @param {NodesAPIApiNodesAPIDeleteNodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAPIDeleteNode(requestParameters: NodesAPIApiNodesAPIDeleteNodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteNodeResponse> {
            return localVarFp.nodesAPIDeleteNode(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         * Drains a node of all workloads.
         * @param {NodesAPIApiNodesAPIDrainNodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAPIDrainNode(requestParameters: NodesAPIApiNodesAPIDrainNodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DrainNodeResponse> {
            return localVarFp.nodesAPIDrainNode(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.drainNodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Interrupts a node.  (-- api-linter: core::0122::cast-api-resource-id-name=disabled      aip.dev/not-precedent: The node API uses the Kubernetes node name as the resource identifier. --)
         * @param {NodesAPIApiNodesAPIInterruptNodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAPIInterruptNode(requestParameters: NodesAPIApiNodesAPIInterruptNodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterruptNodeResponse> {
            return localVarFp.nodesAPIInterruptNode(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.interruptNodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodesAPIDeleteNode operation in NodesAPIApi.
 * @export
 * @interface NodesAPIApiNodesAPIDeleteNodeRequest
 */
export interface NodesAPIApiNodesAPIDeleteNodeRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIDeleteNode
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIDeleteNode
     */
    readonly clusterId: string

    /**
     * The name of the node.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIDeleteNode
     */
    readonly nodeName: string

    /**
     * Force deletion without waiting for the cluster to reach a stable state.  WARNING: This may leave dangling resources in the cluster. Use with caution.
     * @type {boolean}
     * @memberof NodesAPIApiNodesAPIDeleteNode
     */
    readonly force?: boolean
}

/**
 * Request parameters for nodesAPIDrainNode operation in NodesAPIApi.
 * @export
 * @interface NodesAPIApiNodesAPIDrainNodeRequest
 */
export interface NodesAPIApiNodesAPIDrainNodeRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIDrainNode
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIDrainNode
     */
    readonly clusterId: string

    /**
     * The name of the node.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIDrainNode
     */
    readonly nodeName: string

    /**
     * 
     * @type {DrainNodeRequest}
     * @memberof NodesAPIApiNodesAPIDrainNode
     */
    readonly drainNodeRequest: DrainNodeRequest
}

/**
 * Request parameters for nodesAPIInterruptNode operation in NodesAPIApi.
 * @export
 * @interface NodesAPIApiNodesAPIInterruptNodeRequest
 */
export interface NodesAPIApiNodesAPIInterruptNodeRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIInterruptNode
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIInterruptNode
     */
    readonly clusterId: string

    /**
     * The name of the node.
     * @type {string}
     * @memberof NodesAPIApiNodesAPIInterruptNode
     */
    readonly nodeName: string

    /**
     * 
     * @type {InterruptNodeRequest}
     * @memberof NodesAPIApiNodesAPIInterruptNode
     */
    readonly interruptNodeRequest: InterruptNodeRequest
}

/**
 * NodesAPIApi - object-oriented interface
 * @export
 * @class NodesAPIApi
 * @extends {BaseAPI}
 */
export class NodesAPIApi extends BaseAPI {
    /**
     * Deletes a node.
     * @param {NodesAPIApiNodesAPIDeleteNodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesAPIApi
     */
    public nodesAPIDeleteNode(requestParameters: NodesAPIApiNodesAPIDeleteNodeRequest, options?: RawAxiosRequestConfig) {
        return NodesAPIApiFp(this.configuration).nodesAPIDeleteNode(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Drains a node of all workloads.
     * @param {NodesAPIApiNodesAPIDrainNodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesAPIApi
     */
    public nodesAPIDrainNode(requestParameters: NodesAPIApiNodesAPIDrainNodeRequest, options?: RawAxiosRequestConfig) {
        return NodesAPIApiFp(this.configuration).nodesAPIDrainNode(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.drainNodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Interrupts a node.  (-- api-linter: core::0122::cast-api-resource-id-name=disabled      aip.dev/not-precedent: The node API uses the Kubernetes node name as the resource identifier. --)
     * @param {NodesAPIApiNodesAPIInterruptNodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesAPIApi
     */
    public nodesAPIInterruptNode(requestParameters: NodesAPIApiNodesAPIInterruptNodeRequest, options?: RawAxiosRequestConfig) {
        return NodesAPIApiFp(this.configuration).nodesAPIInterruptNode(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.interruptNodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

